var _a;
var target = (_a = process.env.REDIRECT_ORIGIN) !== null && _a !== void 0 ? _a : 'https://mit-cogvio.iqvia.com';
if (target !== '' && window.location.origin !== target) {
    window.location.replace(target + window.location.pathname + window.location.search + window.location.hash);
}
